import { FaIcon } from '@/lib/fa'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import * as React from 'react'
import FlexView from '@/modules/shared/components/FlexView'

type TooltipRow = {
  title: string
  value: string
}

type TooltipLayoutProps = {
  headerColor: string
  headerTitle: string
  headerIcon?: IconProp
  rows: TooltipRow[]
  showVehicleSource?: boolean
  vehicleSourceLabel?: string
  headerTextColor?: string
}

export const TooltipLayout: React.FC<TooltipLayoutProps> = ({
  headerColor,
  headerTitle,
  headerIcon,
  rows,
  showVehicleSource,
  vehicleSourceLabel,
  headerTextColor,
}) => {
  return (
    <div className="tw-overflow-hidden tw-rounded-lg">
      <div
        className={`tw-flex tw-items-center tw-gap-2 tw-rounded-t-lg tw-px-3 tw-py-1 ${headerTextColor ? `tw-text-${headerTextColor}` : 'tw-text-white'}`}
        style={{ backgroundColor: headerColor }}
      >
        {headerIcon && <FaIcon icon={headerIcon} />}
        <p className="tw-text-sm">{headerTitle}</p>
      </div>

      <div className="et-activity-tooltip-body tw-rounded-b-lg tw-bg-[#1F2937]/80 tw-px-3 tw-py-3 tw-text-white">
        <div className="tw-grid tw-grid-cols-2 tw-gap-x-4 tw-gap-y-1">
          {rows.map((row, index) => (
            <React.Fragment key={index}>
              <span className="tw-text-xs tw-font-normal tw-text-white/80">
                {row.title}
              </span>
              <span className="tw-text-xs tw-font-medium">{row.value}</span>
            </React.Fragment>
          ))}
        </div>

        {showVehicleSource && (
          <FlexView style={{ marginTop: 4 }}>
            <img
              src="/assets/icons/pojazdy-white.svg"
              width={19}
              height={19}
              style={{ marginRight: 10 }}
            />
            <span style={{ fontSize: 13 }}>{vehicleSourceLabel}</span>
          </FlexView>
        )}
      </div>
    </div>
  )
}
